import {SERVER} from "../constants";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";
import {productMapperGetOneResponse} from "../panels/product/productMapper";
import {productCategoryMapperGetOneResponse} from "../panels/productCategory/productCategoryMapper";
import {branchMapperGetOneResponse} from "../panels/branch/branchMapper";
import {needMapperGetOneResponse} from "../panels/needs/needMapper";
import {needCategoryMapperGetOneResponse} from "../panels/needCategory/needCategoryMapper";
import {unitMapperGetOneResponse} from "../panels/essentials/unit/unitMapper";
import {mapperGetOneResponse} from "../panels/essentials/unitProcessor/unitProcessorMapper";
import {statusMapperGetOneResponse} from "../panels/essentials/status/statusMapper";
import {statusLoadingMapperGetOneResponse} from "../panels/essentials/statusLoading/statusLoadingMapper";
import {loadingRequestMapperGetOneResponse} from "../panels/loadingRequest/loadingRequestMapper";
import {whatsappMapperGetOneResponse} from "../panels/whatsapp/whatsappMapper";

import { reportMapperGetOneResponse } from "../panels/report/reportMapper";
import { customerMapperGetOneResponse } from "../panels/crm/customer/customerMapper";
import { preferCallMapperGetOneResponse } from "../panels/essentials/preferCall/preferCallMapper";
import { statusCallMapperGetOneResponse } from "../panels/essentials/statusCall/statusCallMapper";
import { packageMapperGetOneResponse } from "../panels/essentials/package/packageMapper";
import { orderTypeMapperGetOneResponse } from "../panels/essentials/orderType/orderTypeMapper";
import { contactMapperGetOneResponse } from "../panels/crm/contact/contactMapper";
import { customerCategoryMapperGetOneResponse } from "../panels/crm/essentials/customerCategory/customerCategoryMapper";
import { contactCategoryMapperGetOneResponse } from "../panels/crm/essentials/contactCategory/contactCategoryMapper";
import { customerPriorityMapperGetOneResponse } from "../panels/crm/essentials/customerPriority/customerPriorityMapper";
import { customerRatingMapperGetOneResponse } from "../panels/crm/essentials/customerRating/customerRatingMapper";
import { storageMapperGetOneResponse } from "../panels/essentials/storage/storageMapper";
import { clueMapperGetOneResponse } from "../panels/crm/clue/clueMapper";
import { reminderMapperGetOneResponse } from "../panels/crm/reminder/reminderMapper";
import { sendSMSMapperGetOneResponse } from "../panels/essentials/sms/SendSMSMapper";
import { notificationsMapperGetOneResponse } from "../panels/essentials/notifications/NotificationsMapper";
import { transactionMapperGetOneResponse } from "../panels/transaction/transactionMapper";
import { adminUserMapperGetOneResponse } from "../panels/adminUsers/adminUsersMapper";
import { baseUnitMapperGetOneResponse } from '../panels/product/details/baseUnit/baseUnitMapper';
import { productUnitMapperGetOneResponse } from '../panels/product/details/productUnit/productUnitMapper';
import { rawMaterialMapperGetOneResponse } from '../panels/product/details/rawMaterial/rawMaterialMapper';
import { productCapacityMapperGetOneResponse } from "../panels/productCapacity/productCapacityMapper";
import { eventPanelMapperGetOneResponse } from "../panels/event/eventMapper";
import { reportInputProductMapperGetOneResponse } from "../panels/reportInputProducts/reportInputProductsMapper";
import { reportProductionMapperGetOneResponse } from "../panels/reportProduction/reportProductionMapper";

export function getOne(resource, params) {
  return HttpClient(`${SERVER}/${MAP_URL[resource]}/${params.id}`).then(({json}) => {
     if (resource === 'productCategory') {
        return productCategoryMapperGetOneResponse(json);
      } else if (resource === 'product') {
        return productMapperGetOneResponse(json);
      } else if (resource === 'branch') {
        return branchMapperGetOneResponse(json);
      } else if (resource === 'need') {
        return needMapperGetOneResponse(json);
      } else if (resource === 'needCategory') {
        return needCategoryMapperGetOneResponse(json);
      } else if (resource === 'unit' ) {
        return unitMapperGetOneResponse(json);
      } else if (resource === 'unitProcessor' ) {
        return mapperGetOneResponse(json);
      } else if (resource === 'status' ) {
        return statusMapperGetOneResponse(json);
      } else if (resource === 'statusCall' ) {
        return statusCallMapperGetOneResponse(json);
      } else if (resource === 'preferCall') {
        return preferCallMapperGetOneResponse( json);
      } else if (resource === 'statusLoading' ) {
        return statusLoadingMapperGetOneResponse(json);
      } else if (resource === 'report' ) {
        return reportMapperGetOneResponse(json);
      } else if (resource === 'reportProduction' ) {
        return reportProductionMapperGetOneResponse(json);
      } else if (resource === 'reportInputProduct' ) {
        return reportInputProductMapperGetOneResponse(json);
      } else if (resource === 'loadingRequest' ) {
        return loadingRequestMapperGetOneResponse(json);
      } else if (resource === 'whatsapp' ) {
        return whatsappMapperGetOneResponse(json);
      } else if (resource === 'customer' ) {
        return customerMapperGetOneResponse(json);
      } else if (resource === 'contact' ) {
        return contactMapperGetOneResponse(json);

      } else if (resource === 'package' ) {
        return packageMapperGetOneResponse(json);
      } else if (resource === 'orderType' ) {
        return orderTypeMapperGetOneResponse(json);
      } else if (resource === 'customerCategory' ) {
        return customerCategoryMapperGetOneResponse(json);
      } else if (resource === 'contactCategory' ) {
        return contactCategoryMapperGetOneResponse(json);
      } else if (resource === 'customerPriority' ) {
        return customerPriorityMapperGetOneResponse(json);
      } else if (resource === 'customerRating' ) {
        return customerRatingMapperGetOneResponse(json);

      } else if (resource === 'storage' ) {
        return storageMapperGetOneResponse(json);

      } else if (resource === 'clue' ) {
        return clueMapperGetOneResponse(json);
      } else if (resource === 'reminder' ) {
        return reminderMapperGetOneResponse(json);
      } else if (resource === 'sendSMS' ) {
        return sendSMSMapperGetOneResponse(json);
      } else if (resource === 'notifications' ) {
        return notificationsMapperGetOneResponse(json);
      } else if (resource === 'transaction' ) {
        return transactionMapperGetOneResponse(json);

      } else if (resource === 'adminUsers' ) {
        return adminUserMapperGetOneResponse(json);

      } else if (resource === 'baseUnit' ) {
        return baseUnitMapperGetOneResponse(json);
      } else if (resource === 'productUnit' ) {
        return productUnitMapperGetOneResponse(json);
      } else if (resource === 'rawMaterial' ) {
        return rawMaterialMapperGetOneResponse(json);
      } else if (resource === 'productCapacity' ) {
        return productCapacityMapperGetOneResponse(json);
      } else if (resource === 'eventPanel' ) {
        return eventPanelMapperGetOneResponse(json);


        
      }
      return {
        data: {...json.result, id: json.result.phoneNumber},
      };
    }
  );
}
